import React, { useEffect, useRef, useState } from "react";
import AnimatedElement from "../AnimatedElement";
import imgPortafolio from "../../assets/images/Retail/imgportafolio.png";
import imgSoluciones1 from "../../assets/images/Retail/imgsoluciones1.png";
import imgSoluciones2 from "../../assets/images/Retail/imgsoluciones2.png";
import imgconsultoria from "../../assets/images/Retail/imgservicios1.JPG";
import imgentrenamiento from "../../assets/images/Retail/imgservicios2.JPG";
import imgsitescajeros from "../../assets/images/Retail/imgservicios3.JPG";
import imgmantenimiento from "../../assets/images/Retail/imgservicios4.png";
import imgmejora from "../../assets/images/Retail/imgmejora.png";
import icon1mejora from "../../assets/images/Retail/icon1mejora.png";
import icon2mejora from "../../assets/images/Retail/icon2mejora.png";
import videoretail from "../../assets/images/Retail/retailVideo.mp4";
import { useTranslation } from "react-i18next";
import "../../i18next";

function SeccionRetail() {
  const { t, i18n } = useTranslation();
  const videoRef = useRef(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const isMobile = window.innerWidth < 768;
  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua);
    setIsIOS(isIOSDevice);
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const dataArray = ["atmsSales", "atmsRent", "atmsServices"];

  const listedItems = dataArray.map((item, index) => (
    <li
      className="font-bold text-fontWhite text-sm md:text-2xl border-b-2 py-2 list-item"
      key={index}
    >
      {t(`retailSection.${item}`)}
      {/* <button className="rounded-full w-8 h-8 md:pb-2 bg-orangeAtm">
        <svg
          type="button"
          className="h-8 w-8 text-fontWhite"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="16" />
          <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
      </button> */}
    </li>
  ));

  return (
    <>
      {/* Título y texto principal */}
      <AnimatedElement fromDirection="top">
        <div className="text-center md:text-left px-4 md:px-10  mx-auto">
          <h1
            className="text-4xl md:text-7xl font-bold text-orangeAtm mb-4"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("retailSection.title")}
          </h1>
          <hr className="border-t-4 border-orangeAtm w-24 mb-4 mx-auto md:mx-0" />
          <h2
            className="text-2xl md:text-5xl font-bold text-orangeAtm mb-6"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("retailSection.transforming")} <br />
            {t("retailSection.marketRetail")}
          </h2>
          <p className="text-base md:text-lg text-darkBlueText">
            {t("retailSection.tecnology")} <br /> {t("retailSection.convert")}
          </p>
        </div>
      </AnimatedElement>

      <AnimatedElement fromDirection="bottom">
        <div className="relative mt-10 mx-auto">
          <div className="w-full aspect-video overflow-hidden relative">
            {/* Render condicional: video en desktop, imagen en móvil */}
            {isMobile ? (
              <img
                src={imgSoluciones2}
                alt="Retail video placeholder"
                className="w-full h-full object-cover"
              />
            ) : (
              <video
                ref={videoRef}
                loop
                muted
                playsInline
                autoPlay={!isIOS}
                className="w-full h-full object-cover"
              >
                <source src={videoretail} type="video/mp4" />
              </video>
            )}

            {!isMobile && isIOS && !isPlaying && (
              <button
                onClick={() => {
                  handlePlay();
                  setIsPlaying(true);
                }}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black text-3xl px-6 py-3 rounded-full z-10"
              >
                ▶
              </button>
            )}
          </div>

          {/* CTA sobre el video o imagen */}
          <div className="mt-6 md:absolute md:bottom-16 md:right-16 bg-black/60 p-6 rounded-lg max-w-md w-full">
            <h4
              className="text-white font-bold text-xl md:text-3xl underline underline-offset-8 mb-4"
              style={{ fontFamily: "Helvetica" }}
            >
              {t("retailSection.services")}
            </h4>
            <button
              onClick={() => scrollToSection("servicesSection")}
              className="h-12 text-white text-lg font-medium bg-orangeAtm rounded-full px-6 w-full md:w-auto text-center"
            >
              {t("retailSection.learn")}
            </button>
          </div>
        </div>
      </AnimatedElement>

      <section className="bg-gradient-to-b from-white to-[#19235C] py-16 px-5 ">
        {/* Mejora de experiencia */}
        <section className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 items-start">
          {/* Texto lateral */}
          <div className="flex-1 flex flex-col justify-between h-full">
            <AnimatedElement fromDirection="top">
              <h3
                className="text-3xl md:text-5xl font-bold text-orangeAtm mb-6"
                style={{ fontFamily: "Helvetica" }}
              >
                {t("retailSection.inprove")}
              </h3>
            </AnimatedElement>

            <div className="flex-1 flex flex-col justify-between ">
              <AnimatedElement fromDirection="top">
                <p
                  className="text-sm md:text-lg text-fontWhite text-justify mb-8 md:mt-24"
                  style={{ fontFamily: "Helvetica" }}
                >
                  {t("retailSection.ourExperience")}
                </p>
              </AnimatedElement>

              <div className="flex flex-col justify-between">
                {/* Iconos */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:mt-24">
                  {/* Icono 1 */}
                  <div fromDirection="left" className="flex items-center gap-6">
                    <img
                      src={icon1mejora}
                      alt="interactive units"
                      className="w-12 h-12"
                    />
                    <p className="text-fontWhite text-sm md:text-lg whitespace-pre-line">
                      {t("retailSection.interactive")}
                    </p>
                  </div>

                  {/* Icono 2 */}
                  <div fromDirection="left" className="flex items-center gap-6">
                    <img
                      src={icon2mejora}
                      alt="development and implementation"
                      className="w-12 h-12"
                    />
                    <p className="text-fontWhite text-sm md:text-lg ">
                      {t("retailSection.development")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Imagen lateral */}
          <div className="flex-1">
            <AnimatedElement fromDirection="right">
              <img
                src={imgmejora}
                alt="improving security"
                className="w-full rounded-lg object-cover"
              />
            </AnimatedElement>
          </div>
        </section>
      </section>

      {/* Portafolio */}
      <section className="mx-auto">
        <AnimatedElement fromDirection="bottom">
          <div className="relative flex justify-center">
            {/* Título en la parte superior derecha */}
            <h2 className="absolute top-0 right-0 mt-6 mr-6 text-4xl md:text-8xl font-bold text-white font-roboto z-20">
              {t("retailSection.portfolio")}
            </h2>

            {/* IMAGEN */}
            <img
              src={imgPortafolio}
              alt="retail portfolio"
              className="w-full h-[600px] object-cover"
            />
          </div>
        </AnimatedElement>
      </section>

      <section id="servicesSection" className="bg-darkBlueText py-16 px-4">
        <h2 className="text-4xl md:text-6xl font-bold text-orangeAtm font-roboto mb-10 text-center pl-2 md:pl-10">
          {t("retailSection.servicios")}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 max-w-7xl mx-auto">
          {/* Consultoría */}
          <div className="relative w-full h-[306px]">
            <img
              src={imgconsultoria}
              alt="consulting services"
              className="w-full h-full object-cover "
            />
            <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-xl font-bold w-fit">
              {t("retailSection.consulting")}
            </h4>
          </div>

          {/* Entrenamiento */}
          <div className="relative w-full h-[306px]">
            <img
              src={imgentrenamiento}
              alt="training services"
              className="w-full h-full object-cover "
            />
            <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-xl font-bold w-fit">
              {t("retailSection.training")}
            </h4>
          </div>

          {/* Sitios de cajeros */}
          <div className="relative w-full h-[306px]">
            <img
              src={imgsitescajeros}
              alt="construction sites"
              className="w-full h-full object-cover "
            />
            <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-xl font-bold w-fit">
              {t("retailSection.construction")}
            </h4>
          </div>

          {/* Mantenimiento */}
          <div className="relative w-full h-[306px]">
            <img
              src={imgmantenimiento}
              alt="maintenance services"
              className="w-full h-full object-cover "
            />
            <h4 className="absolute bottom-4 left-4 bg-black/50 text-fontWhite px-4 py-2 rounded text-lg md:text-xl font-bold w-fit">
              {t("retailSection.mantainance")}
            </h4>
          </div>
        </div>
      </section>

      {/**seccion Productos */}
      <section className="bg-darkBlueText py-8 md:px-20">
        <AnimatedElement fromDirection="bottom">
          <h2 className="text-4xl md:text-6xl font-bold text-orangeAtm font-roboto mb-10 text-center md:text-left pl-2 md:pl-10">
            {t("retailSection.products")}
          </h2>
          <div className="flex justify-center md:justify-end md:px-16 ">
            <div className="w-5/6 mx-auto md:w-1/2 md:mx-0">
              <ul className="list-disc pl-6 space-y-4">{listedItems}</ul>
            </div>
          </div>
        </AnimatedElement>
      </section>
    </>
  );
}

export default SeccionRetail;
